import { useNavigate } from 'react-router-dom';
import { useSeoMeta } from '@unhead/react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Wallet, Server } from 'lucide-react';
import { useAppMode } from '@/contexts/ModeContext';
import { isMintSetupComplete } from '@/lib/storage/mint-store';
import { useEffect, useState } from 'react';

const Index = () => {
  const navigate = useNavigate();
  const { setMode } = useAppMode();
  const [mintReady, setMintReady] = useState(false);

  useSeoMeta({
    title: 'Cashero — Ecash for Monero over Nostr',
    description: 'A Cashu-inspired ecash mint and wallet using Monero (XMR) deposits and withdrawals, communicating over Nostr.',
  });

  useEffect(() => {
    isMintSetupComplete().then(setMintReady);
  }, []);

  const goWallet = () => {
    setMode('wallet');
    navigate('/wallet');
  };

  const goMint = () => {
    setMode('mint');
    navigate('/mint');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <div className="max-w-lg w-full space-y-8 text-center">
        <div>
          <h1 className="text-5xl font-bold mb-2 bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
            Cashero
          </h1>
          <p className="text-muted-foreground text-lg">
            Ecash for Monero over Nostr
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Card
            className="cursor-pointer transition-all hover:shadow-lg hover:border-primary/50 border-2"
            onClick={goWallet}
          >
            <CardHeader className="pb-2">
              <div className="flex justify-center mb-2">
                <Wallet className="h-10 w-10 text-primary" />
              </div>
              <CardTitle className="text-center">Wallet</CardTitle>
              <CardDescription className="text-center text-xs">
                Send, receive, and manage ecash
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button className="w-full" variant="default" onClick={goWallet}>
                Use Wallet
              </Button>
            </CardContent>
          </Card>

          <Card
            className="cursor-pointer transition-all hover:shadow-lg hover:border-primary/50 border-2"
            onClick={goMint}
          >
            <CardHeader className="pb-2">
              <div className="flex justify-center mb-2">
                <Server className="h-10 w-10 text-primary" />
              </div>
              <CardTitle className="text-center">Mint Operator</CardTitle>
              <CardDescription className="text-center text-xs">
                Run a mint backed by Monero
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button className="w-full" variant="secondary" onClick={goMint}>
                {mintReady ? 'Manage Mint' : 'Set Up Mint'}
              </Button>
            </CardContent>
          </Card>
        </div>

        <p className="text-xs text-muted-foreground">
          <a href="https://shakespeare.diy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
            Vibed with Shakespeare
          </a>
        </p>
      </div>
    </div>
  );
};

export default Index;
